






































import { Component, Vue } from 'vue-property-decorator';
import { Actions } from '@/ts/store/Constants';
import ProjectInfo from '@/components/Admin/Panels/Project/ProjectTabs/ProjectInfo.vue';
import ProjectEmailSignature from '@/components/Admin/Panels/Project/ProjectTabs/ProjectEmailSignature.vue';

@Component({
    components: {
        ProjectInfo,
        ProjectEmailSignature,
    },
})
export default class ProjectLanding extends Vue {
    public activeTab: number = 0;
    public tabs = [
        { name: this.$t('general.project-info', 'Project info'), component: 'ProjectInfo' },
        { name: this.$t('general.email-signature', 'Email signature'), component: 'ProjectEmailSignature' },
    ];

    constructor() {
        super();
    }

    get currentTabView() {
        return this.tabs[this.activeTab].component;
    }

    public mounted() {
        const projectId = this.$route.params.projectId;

        if (typeof projectId !== 'undefined') {
            this.$store.dispatch(Actions.FETCH_PROJECT, projectId);
        }
    }
}
